import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useIsHovering } from '../../../hooks/useIsHovering';
import { ButtonLabel } from '../ButtonLabel';
import { StyledFlexColumn } from '../styles';
import { ImageInputButton } from './ImageInputButton';
/** Regular toggle button with a label attached to it.
 * This represents either a checkbox or a radio button.
 */
export const GuidaImageInputButton = ({ imageUrl, label, onClick, selected, dataTestId, inputType, aspectRatio, subtle, disabled, isKiosk, description, value }) => {
    const inputId = `toggle-button-${inputType}-${value}`;
    const { isHovering, onRef } = useIsHovering();
    return (_jsxs(StyledFlexColumn, { ref: onRef, children: [_jsx(ImageInputButton, { inputId: inputId, onClick: onClick, selected: selected, isKiosk: isKiosk, inputType: inputType, value: value, aspectRatio: aspectRatio, imageUrl: imageUrl, disabled: disabled, dataTestId: dataTestId, isHovering: isHovering }), label && (_jsx(ButtonLabel, { htmlFor: inputId, subtle: subtle, text: label, description: description }))] }));
};
//# sourceMappingURL=GuidaImageInputButton.js.map